import request from '@/utils/request'

// 获取课表列表（适配java110框架）
export function getCourseScheduleList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: "/courseSchedule.QueryCourseScheduleCmd",
      method: "get",
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增课表信息
export function addCourseSchedule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/courseSchedule.SaveCourseScheduleCmd",
      method: "post",
      data: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 编辑课表信息
export function editCourseSchedule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/courseSchedule.UpdateCourseScheduleCmd",
      method: "post",
      data: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除单个课表信息
export function deleteCourseSchedule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/courseSchedule.DeleteCourseScheduleCmd",
      method: "post",
      data: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 批量删除课表信息
export function batchDeleteCourseSchedule(scheduleIds) {
  return new Promise((resolve, reject) => {
    request({
      url: "/courseSchedule.DeleteCourseSchedulesCmd",
      method: "post",
      data: { ids: scheduleIds }
    }).then(response => {
      const res = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导入课表（Excel导入）
export function importCourseSchedule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/courseSchedule.ImportCourseScheduleCmd",
      method: "post",
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data' // 表单上传类型
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导出课表（Excel导出）
export function exportCourseSchedule(params) {
  return new Promise((resolve, reject) => {
    request({
      url: "/courseSchedule.ExportCourseScheduleCmd",
      method: "get",
      params,
      responseType: 'blob' // 导出返回二进制流（Excel文件）
    }).then(response => {
      resolve(response) // 直接返回response，不解析data
    }).catch(error => {
      reject(error)
    })
  })
}